import { render, staticRenderFns } from "./SpaceInfo.vue?vue&type=template&id=551df416&scoped=true&"
import script from "./SpaceInfo.vue?vue&type=script&lang=js&"
export * from "./SpaceInfo.vue?vue&type=script&lang=js&"
import style0 from "./SpaceInfo.vue?vue&type=style&index=0&id=551df416&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551df416",
  null
  
)

export default component.exports